import packageJson from '../../package.json';
export const host = import.meta.env.VITE_BACKEND_ENDPOINT;

export const config = {
	environment: import.meta.env.VITE_ENVIRONMENT || 'development-localhost',
	bugsnagKey: import.meta.env.VITE_BUGSNAG_API_KEY || 'DO_NOT_SEND',
	brandingEndpoint: import.meta.env.VITE_BRANDING_QUESTIONNAIRE_ENDPOINT || '',
	appVersion: packageJson.version,
	isDevelopment:
		import.meta.env.VITE_ENVIRONMENT?.startsWith('dev') ||
		import.meta.env.VITE_ENVIRONMENT?.startsWith('localhost') ||
		false,
	posthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY || '',
	posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || '',
	ctrPamphletUrl:
		import.meta.env.VITE_CTR_PAMPHLET_URL || 'https://www.fincen.gov/sites/default/files/shared/CTRPamphlet.pdf',
};

export const Localization = {
	DefaultLanguageCode: import.meta.env.VITE_DEFAULT_LANGUAGE_CODE || 'en-US',
	SupportedLanguages: import.meta.env.VITE_SUPPORTED_LANGUAGES?.split(',') || ['en-US', 'es-ES', 'en-UK'],
};

export const Attachments = {
	SupportedExtensions: import.meta.env.VITE_REFINE_ATTACHMENT_SUPPORTED_EXTENSIONS?.split(',') || [
		'pdf',
		'doc',
		'docx',
		'xls',
		'xlsx',
		'jpg',
		'jpeg',
		'png',
		'heic',
	],
	AttachmentSizeLimit: Number(import.meta.env.VITE_REFINE_ATTACHMENT_MAX_SIZE_B || 50000000),
};
